<div class="box card-box row m-x-xs" *ngIf="claimTypes">
  <div class="box-header">
    <h3>{{'WORKFLOWS.claim' | translate}}</h3>
  </div>
  <div class="box-body">
    <gp-claim-form
      [claimForm]="claimForm"
      [isTaskDescription]="true"
      [cliRegId]="cliRegId"
      [contractId]="contractId"
      [claimTypes]="claimTypes"
      [selectedClaim]="requestVariable.value"
      [claimTypeTree]="claimTypeTree"
      (requestUpdate)="onRequestUpdate($event)"
      [isEss]="false"
    ></gp-claim-form>
  </div>
</div>
